import { Router } from '@angular/router';
import { WizardViewModel } from '../wizard-view-model';
import { VisitTypeAssignment } from "../VisitTypeAssignment";
import { DentallyWizardService } from '../dentally-wizard.service';
import { Component, OnInit } from '@angular/core';
import { IHasStepNumber } from 'src/core/interfaces/IHasStepNumber';
import { OrgSettingsService } from 'src/org-settings/org-settings.service';
import { TreatmentMapping } from "../TreatmentMapping";

@Component({
  selector: 'app-dentally-map',
  templateUrl: './dentally-learn.component.html',
  styleUrls: ['./dentally-learn.component.scss']
})
export class DentallyLearnComponent implements OnInit, IHasStepNumber {

  constructor(private settingsService: OrgSettingsService, private dentallyService: DentallyWizardService, private router: Router) { }
  stepNumber: number = 1;
  wizardState: WizardViewModel;

  ngOnInit() {
    this.dentallyService.GetTreatments().subscribe(
      (response: TreatmentMapping[]) => {
        const visitTypes = response;
        this.transformTreatments(visitTypes);          
      });
  }

  private transformTreatments(visitTypes: TreatmentMapping[]) {
    this.dentallyService.getWizardState()
      .subscribe(r => {
        this.wizardState = r;
        const tempTxs = r.data.treatments.sort((t1, t2) => {
          if (t1.code < t2.code) { return -1; }
          if (t1.code > t2.code) { return 1; }
          return 0;
        });
        tempTxs.forEach(t => {
          const treatment = { code: t.code, name: t.patient_description, toMap: false } as any;
          let vt = visitTypes.find(v => v.dentallyTreatmentId === t.code);
          if (!vt) {
            treatment.toMap = true;
            treatment.visitType = "Other";
          } else {
            treatment.visitType = vt.facVisitTypeName;
          }
          this.treatments.push(treatment);

        });
      });
  }

  updateMapping() {
    const assignedVisitTypes: VisitTypeAssignment[] = this.treatments.map(t => {
      return { visitTypeName: t.visitType, itemCodes: [t.code] }
    });   
    this.wizardState.data.visitTypeAssignments = assignedVisitTypes;
    this.dentallyService.updateWizardStep(this.wizardState)
      .subscribe(s => {
        this.router.navigateByUrl("/wizard/dentally/start");
      });
  }

  onContinueClick() {
    this.updateMapping();
  }

  treatments: { code: string, name: string, visitType: string, toMap: boolean }[] = [];
 
}
